exports = module.exports = require("../../../../css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.configured-icon {\n  color: green;\n}\n.configured-icon:hover {\n    cursor: pointer;\n}\n", "", {"version":3,"sources":["/usr/src/app/node_modules/@intelipost-modules/secure-recon/features/configuration-sefaz/PageConfigurationSefaz.vue"],"names":[],"mappings":";AACA;EACE,aAAa;CACd;AACD;IACI,gBAAgB;CACnB","file":"PageConfigurationSefaz.vue","sourcesContent":["\n.configured-icon {\n  color: green;\n}\n.configured-icon:hover {\n    cursor: pointer;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6ae2de16","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./node_modules/@intelipost-modules/secure-recon/features/configuration-sefaz/PageConfigurationSefaz.vue
// module id = BdV9
// module chunks = 72